export class SlamCompetitor {
    constructor(data) {

        this.id = data.id;
        this.first_name = data && data.first_name ? data.first_name : "";
        this.last_name = data && data.last_name ? data.last_name : "";
    }
}